// src/utils/saveStoreSettings.js

/**
 * حفظ إعدادات المتجر بناءً على slug
 */
export const saveStoreSettings = (data, slug) => {
    return new Promise((resolve, reject) => { 
        if (!data) return reject("No data provided");
        if (!slug) return reject("No slug provided");
        
        const settings = {
            identity_color: data.identity_color,
            lang: data.lang,
            products_show_method: data.products_show_method,
            default_page: data.default_page,
            views_active: data.views_active,
            ratings_active: data.ratings_active,
        };
        
        // 🔥 حفظ slug-specific
        const key = `store_settings-${slug}`;
        localStorage.setItem(key, JSON.stringify(settings));
        
        // 🔥 أيضاً حفظ نسخة global للتوافق (اختياري)
        localStorage.setItem('store_settings', JSON.stringify(settings));
        
        resolve(settings);
    });
};

/**
 * قراءة إعدادات المتجر بناءً على slug
 */
export const getStoreSettings = (slug) => {
    if (!slug) {
        // fallback للـ global settings
        const settings = localStorage.getItem('store_settings');
        return settings ? JSON.parse(settings) : null;
    }
    
    const key = `store_settings-${slug}`;
    const settings = localStorage.getItem(key);
    return settings ? JSON.parse(settings) : null;
};
